import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Cards from './Cards';

class Tablero extends Component {
  constructor(){
    super();
    this.state = {
      cards: [],
      priorities: [],
      notes: [],
    }
  }
  componentWillMount() {
    if (!this.props.tab) {
      this.props.db("tableros-home");
    }
  }
  reloadTabs = () => {
    let date = this.props.date;
    let dateISO = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate();
    this.props.db("tableros-home", false, dateISO);
  }
  render() {
    let {avTabs, vis, url, uID} = this.props;
    let tab;
    //If there's no selected tablero, check the url for an ID
    let match = this.props.match.params.id;
    let selected = Object.keys(avTabs).find((key) => {
      let tabsel = avTabs[key];
      return tabsel[0].id === match
    });
    selected = avTabs[selected];
    if (selected) {
      tab = selected[0];
      vis = selected[1];
    }
    return (
      <div className="tablero">
        {
        Object.keys(vis).map((key) => {
          let visual = vis[key];
          let card = null;
          if (Object.keys(visual.card).length !== 0) {
            card = visual.card
          }
          return (
            <Cards 
              uID={uID}
              reload={this.reloadTabs}
              tab={tab}
              card={card} 
              url={url} 
              vis={visual} 
              key={key} 
              tkn={this.props.tkn}
              msg={this.props.msg}/>
          )
        })}
      </div>
    )
  }
}

export default withRouter(Tablero);


// WEBPACK FOOTER //
// ./src/Components/Boards/Tablero.js